const concat = "<br />"

const liquidationfaq = {
  "About Liquidation Program": [
    // {
    //   question: "Can I liquidate my MLD before maturity?",
    //   answer: "'Anytime Liquidity' feature offers liquidity to investors anytime starting from 7 working days after the close of an issue, until its Maturity. Once the request for Liquidation is placed on the portal, we will complete the transaction within Seven working days. You can request for liquidation anytime by clicking the ‘Liquidate’ button in the portfolio."
    // },
    // {
    //   question: "At what price would the MLD be liquidated?",
    //   answer: "The latest mark to market price per unit is refreshed within 1 working day of the request for liquidation being placed. The liquidation will happen at this price minus a fee of 2%."
    // },
    {
      question: "How will the process of Liquidation work?",
      answer: "On confirmation by the investor, liquidity sale transaction will be processed within 7 working days thereafter." + concat +
      "Liquidity sale will be a 2-step process:" + concat +
      "a. On platform transaction" + concat +
      "b. Off platform transaction" + concat +
      "Both the steps need to be completed to ensure the liquidity sale transaction is fully completed. Partial completion will lead to partial liquidity sale transaction. The investment would be liquidated but not paid out until the full completion of the liquidity sale process."
    },
    {
      question: "Are there any charges or fees for liquidation?",
      answer: "Yes, there is a 2% fee which will be applied to the latest market to market price per unit."
    },
    {
      question: "Is my Principal protected if I exit the investment before maturity?",
      answer: "No. The principal is protected only if the investor stays invested till the tenure of the product."
    },
    {
      question: "Is it possible to partially liquidate my investments or must I redeem the full amount at once?",
      answer: "You have the flexibility to partially liquidate your investments or redeem the entire units at once, depending on your liquidity needs. During the liquidation process, you can specify the quantity you wish to redeem."
    }
  ],
}

export default liquidationfaq;